import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const hrAttr = makeAttrStruct([
    ['class']
]);
export const hrData = makeDataStruct([]);
export const hrModel = makeStruct([
    ['attributes', hrAttr],
    ['data', hrData]
]);
// Simplified Model
export function hr(className) {
    return hrModel(hrAttr(className), hrData());
}
/** A horizontal rule */
export default class HR extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.HR, model);
    }
}
